// Labels for the dev sign-in UI. Imported by both the client component
// (DevSignIn.tsx) and the server catalog (catalog.ts); the latter enriches
// each id with email/adTeams/etc. that never leave the server.

export type DevUserLabel = {
  id: string
  label: string
}

export const DEV_USER_LABELS = [
  { id: 'admin', label: 'Admin Anna' },
  { id: 'innendienst', label: 'Innendienst Iris' },
  { id: 'aussendienst', label: 'Aussendienst Aaron' },
  { id: 'antibiose', label: 'Team Antibiose Tilman' },
  { id: 'readonly', label: 'Readonly Rita' },
] as const satisfies readonly DevUserLabel[]

export type DevUserId = (typeof DEV_USER_LABELS)[number]['id']
